import { apiFetch } from "../Utils/ApiClient";
const source_id = Number(process.env.REACT_APP_SOC_ID || 1);

export const getCountry = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/health/countries`, { method: 'GET' });
      return val;
    } catch (error) {
      console.error('Error in getCountry:', error);
      throw error;
    }
  };
};

export const getOccupation = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/get-occupations`, { method: 'GET' });
      return val;
    } catch (error) {
      console.error('Error in getOccupation:', error);
      throw error;
    }
  };
};


export const getTermPlans = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/term-plan/premium`, { method: 'GET' });
      return val;
    } catch (error) {
      console.error('Error in getOccupation:', error);
      throw error;
    }
  };
};

export const getQuoteTermPlan  = (data) => {
    
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/get-quotation/term-plan`, {
        method: 'POST',
        body: JSON.stringify({ ...data, source_id }),
        headers: { 'Content-Type': 'application/json' },
      });
      return val;
    } catch (error) {
      console.error('Error in getQuote:', error);
      throw error;
    }
  };
};

export const addPolicyTermPlan = (data) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/add-policy/term-plan`, {
        method: 'POST',
        body: JSON.stringify({ ...data, source_id }),
        headers: { 'Content-Type': 'application/json' },
      });
      return val;
    } catch (error) {
      console.error('Error in addPolicy:', error);
      throw error;
    }
  };
};

export const getPolicyDetailsTermPlan = (policyNo) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/get-policy/${policyNo}`, { method: 'GET' });
      return val;
    } catch (error) {
      console.error('Error in getpolicyterms:', error);
      throw error;
    }
  };
};

export const getQuestionsTermPlan = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/term-plan/questions`, { method: 'GET' });
      return val;
    } catch (error) {
      console.error('Error in getQuestion:', error);
      throw error;
    }
  };
};

export const getPlanDocumentLife = (policy) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/life/document/download/${policy}`,
        { method: "GET" }
      );
      return val;
    } catch (error) {
      console.error("Error in getIndividualPlanOptions:", error);
      throw error;
    }
  };
};
